import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MethodSection } from '../components/MethodSection';
import { AudienceSection } from '../components/AudienceSection';
import { OfferSection } from '../components/OfferSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden selection:bg-terracotta/20 selection:text-terracotta" data-id="element-141">
      <HeroSection data-id="element-142" />
      <PainSection data-id="element-143" />
      <MethodSection data-id="element-144" />
      <AudienceSection data-id="element-145" />
      <OfferSection data-id="element-146" />

      <footer className="w-full py-12 text-center text-charcoal/40 text-sm border-t border-stone/50 bg-white/50" data-id="element-147">
        <p data-id="element-148">
          © {new Date().getFullYear()} Duelo Libre 40+. Todos los derechos
          reservados.
        </p>
        <div className="mt-4 space-x-4" data-id="element-149">
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-150">
            Términos
          </a>
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-151">
            Privacidad
          </a>
          <a href="#" className="hover:text-charcoal/60 underline" data-id="element-152">
            Contacto
          </a>
        </div>
      </footer>
    </main>;
}